export const Scrolltome = (respuesta) => {
    window.document.onscroll = () =>{
        let vertical = window.scrollY;
        if (vertical > 63) respuesta("nav-fixed")
        if (vertical === 0) respuesta("nav-absolute")
    }
}


// WEBPACK FOOTER //
// ./src/funciones/ScrollFunction.jsx